import React from 'react';
import './EventCard.css';

export default function EventCard({ details, showDayOnTimestamp, toggleModal, mode}) {
  const ongoing = Date.now() > details.start && Date.now() < details.end;
  const ended = Date.now() >= details.end;

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const isTomorrow = details.start.getDate() === tomorrow.getDate();

  const displayTime = (
    <time>
      { showDayOnTimestamp && isTomorrow 
        && <span>{Intl.DateTimeFormat('en-US', {weekday: 'short'}).format(tomorrow) + ' at '}</span>
      }
      {ongoing ? 'now' : ended ? 'ended' : details.displayTime}
    </time>
  );
  if (mode === '1') {
    return (
      <article onClick={() => toggleModal(details.eventID)}>
        <div className={`Event ${ended ? 'ended' : ''}`}>
          { details.vwwOtd && 
            <span className="vww-banner">
            <div>VWW</div>
            <div>OF THE DAY</div>
            </span> 
          }
          <div className="image-container">
            <img 
              src={ details.imageUrl }
              alt="Cover art" 
            />
            { ongoing && 
              <span className="in-progress-banner">IN PROGRESS</span> 
            }
          </div>
          {displayTime}
          <p>{ details.title }</p>
        </div>
      </article>
    );
  } else {
    return (
      <article>
        <a href={`https://www.utherverse.com/Events/Event/?EventID=${details.eventID}`}>
          <div className={`Event ${ended ? 'ended' : ''}`}>
            { details.vwwOtd && 
              <span className="vww-banner">
              <div>VWW</div>
              <div>OF THE DAY</div>
              </span> 
            }
            <div className="image-container">
              <img 
                src={ details.imageUrl }
                alt="Cover art" 
              />
              { ongoing && 
                <span className="in-progress-banner">IN PROGRESS</span> 
              }
            </div>
            {displayTime}
            <p>{ details.title }</p>
          </div>
        </a>
      </article>
    );
  }
}
